export default __webpack_public_path__ + "static/bcorp-logo-fr-67baf13405164b129f0ae61a766fddbf.png";